module.exports = __webpack_public_path__ + "img/fb.f9be6ca4.svg";